import React from 'react';
import './src/styles/Globals.css';
import 'typeface-creepster';
import 'typeface-dm-sans';

import { NotificationProvider } from './src/context/AddItemNotificationProvider';
import { CartProvider } from './src/context/CartContext';

export const wrapRootElement = ({ element }) => (
  <NotificationProvider>
    <CartProvider>
      {element}
    </CartProvider>
  </NotificationProvider>
);

export const onClientEntry = () => {
  // Initialize DDT Analytics on client-side only if properly configured
  if (typeof window !== 'undefined' && window.DDTAnalytics) {
    const apiUrl = process.env.GATSBY_CONTROL_HUB_URL;
    const analyticsEnabled = apiUrl && !apiUrl.includes('your-control-hub-domain');

    if (analyticsEnabled) {
      window.DDTAnalytics.init({
        apiUrl: apiUrl,
        websiteId: 'drop-dead-thread-main',
        enableRealTime: true,
        enableHeatmaps: true,
        enableFormTracking: true,
        enableEcommerce: true,
        debugMode: process.env.NODE_ENV === 'development'
      });
    }
  }
};
